/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { priorityOptions, renderPriorities } from '@sketchnote/shared-components';
import { GridApi } from 'ag-grid-community';
import * as React from 'react';
import { useTableStore } from 'src/features/list/store';
import useOnClickOutside from 'use-onclickoutside';

const { useRef, memo } = React;

const PriorityCell = ({
  data: item,
  api,
  onChange,
}: {
  data: any;
  api: GridApi;
  onChange?: (item: any, value) => void;
}) => {
  const { setItem, onUpdateItemField } = useTableStore((s) => ({
    setItem: s.setItem,
    onUpdateItemField: s.onUpdateItemField,
  }));
  const myRef = useRef(null);
  const { isReadOnly } = useTableStore();
  const handleChange = (value) => {
    const priority = value;
    onChange?.(item, priority);
    if (item?.id) {
      onUpdateItemField({ item: { priority, id: item.id }, keys: ['priority'] });
      setItem({
        columnId: item.isSubtask ? item.parentColumn : item.colId,
        item: { ...item, priority: value },
        itemId: item.id,
      });
    }
    api.applyTransaction({ update: [{ ...item, priority }] });
    api.stopEditing();
  };

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  return (
    <div className="more-menu-popover" ref={myRef}>
      <div className="bg-white p-2 flex flex-col gap-0 justify-center  min-w-200 cursor-pointer">
        {priorityOptions.map((priority) => {
          return (
            <div
              onClick={handleChange.bind(null, priority.value)}
              key={priority.label}
              className="flex px-10 h-40 items-center hover:bg-gray-100"
              style={{ color: priority.color }}
            >
              <span className="mr-8 block">{renderPriorities[priority.value]}</span>
              <span className="text-sm block">
                {priority.label[0].toUpperCase() + priority.label.substring(1)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const PriorityCellEditor = memo(PriorityCell);
